import { Box, Button, Checkbox, FormControlLabel, TextField } from "@mui/material"
import { useFormik } from "formik"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import * as yup from "yup"
import Spinner from "../../../../components/Spinner"
import toastWrapper from "../../../../components/toastWrapper"
import { createTargetContractInfo, getTargetContractInfo, updateTargetContractInfo } from "../../../../redux/entrantForm/targetContrantInfoSlice"
import OrganizationSearch from "./OrganizationSearch"

const TargetContractInfo = ({ userInfo }) => {

    const { data, isLoading } = useSelector(x => x.entrantForm.targetContract)

    const dispatch = useDispatch()

    React.useEffect(() => {
        if (userInfo?.id) dispatch(getTargetContractInfo(userInfo.id))
    }, [dispatch, userInfo])


    const { handleSubmit, handleChange, values, errors, touched, setFieldValue } = useFormik({
        initialValues: data,
        enableReinitialize: true,
        validationSchema: yup.object({
            number: yup.string().required(),
            organization_name: yup.string().required(),
            is_posted_on_portal: yup.boolean().required(),
        }),
        onSubmit: values => {
            const newValues = { ...values, user: userInfo.id }
            dispatch(values.id ? updateTargetContractInfo(newValues) : createTargetContractInfo(newValues)).unwrap()
                .then(() => { toastWrapper("Изменения сохранены", "success") })
                .catch(e => {
                    console.error(e)
                    toastWrapper(e?.getUserMessage ? e.getUserMessage() : "Не удалось сохранить изменения")
                })
        }
    })

    const componentHeight = 220

    if (isLoading) return <Spinner height={componentHeight} />

    return <Box sx={{ height: componentHeight }}>
        <TextField
            id="number"
            name="number"
            label="Номер заявки"
            fullWidth
            disabled={!values.can_edit_and_delete}
            value={values.number}
            error={errors.number && Boolean(touched.number)}
            onChange={handleChange}
        />

        <FormControlLabel
            control={<Checkbox
                checked={values.is_posted_on_portal}
                onChange={e => setFieldValue("is_posted_on_portal", e.target.checked)}
            />}
            label="Заявка размещена на портале Работа в России"
        />

        <OrganizationSearch
            initialSearch={values.organization_name}
            onChange={value => setFieldValue("organization_name", value)}
            disabled={!values.can_edit_and_delete}
            error={errors.organization_name && Boolean(touched.organization_name)}
            required
        />

        <Button
            disabled={!values.can_edit_and_delete}
            variant="contained"
            fullWidth
            sx={{ mt: 1 }}
            onClick={handleSubmit}
        >
            Сохранить
        </Button>
    </Box>
}

export default TargetContractInfo